import accounts from 'modules/accounts/reducer'
import imports from 'modules/imports/reducer'

export const rootReducer = [
  {
    key: 'accounts',
    reducer: accounts
  },
  {
    key: 'imports',
    reducer: imports
  }
]